"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randInt = void 0;
var randInt = function (min, max) {
    return min + Math.floor((max - min + 1) * Math.random());
};
exports.randInt = randInt;
